import { useState, useEffect } from "react";
import { json } from "react-router-dom";
import styled from "styled-components";
import * as S from "../HomeStyle";

const SatConc = () => {
  const [visibleBtn, setVisibleBtn] = useState("none");
  const [visibleArea, setVisibleArea] = useState("inline-block");

  const [sizeCheck, setSizeCheck] = useState("");
  const [jsonString, setJSONString] = useState();
  const [bodyRows, setBodyRows] = useState([]);
  const [numOfRows, setNumOfRows] = useState();
  const [numOfColumns, setNumOfColumns] = useState();
  const [area, setArea] = useState("");
  const [data, setData] = useState("");
  let output = [];

  const constructTableFromPasetedInput = (input) => {
    setData(input.target.value);
  };

  // 그리드
  const makeGrid = (output, row, col) => {
    let hereColor = "white";
    let arr = output;
    let cols = col;
    let tag = "";

    // min max 찾기
    let numArr = [];
    arr.map((cols) => {
      cols.map((num) => {
        numArr.push(num);
      });
    });
    let rangeMin = Math.min(...numArr);
    let rangeMax = Math.max(...numArr);
    let gap = (rangeMax - rangeMin) / 10;

    for (let i = 0; i < arr.length; i++) {
      tag += "<tr>";

      for (let j = 0; j < cols; j++) {
        let here = parseInt(arr[i][j]);

        // 색깔 범위 지정
        if (here >= rangeMin + gap * 9) {
          // max 90%
          hereColor = "#ff0000";
        } else if (here >= rangeMin + gap * 8 && here < rangeMin + gap * 9) {
          // max 80%
          hereColor = "#FF1818";
        } else if (here >= rangeMin + gap * 7 && here < rangeMin + gap * 8) {
          // max 70%
          hereColor = "#FD2F2F";
        } else if (here >= rangeMin + gap * 6 && here < rangeMin + gap * 7) {
          // max 60%
          hereColor = "#FF4141";
        } else if (here >= rangeMin + gap * 5 && here < rangeMin + gap * 6) {
          // max 50%
          hereColor = "#FF5C5C";
        } else if (here >= rangeMin + gap * 4 && here < rangeMin + gap * 5) {
          // max 40%
          hereColor = "#FF6F6F";
        } else if (here >= rangeMin + gap * 3 && here < rangeMin + gap * 4) {
          // max 30%
          hereColor = "#FF7E7E";
        } else if (here >= rangeMin + gap * 2 && here < rangeMin + gap * 3) {
          // max 20%
          hereColor = "#FD8B8B";
        } else if (here >= rangeMin + gap * 1 && here < rangeMin + gap * 2) {
          // max 10%
          hereColor = "#FF9D9D";
        } else if (here >= rangeMin && here < rangeMin + gap * 1) {
          // max 0%
          hereColor = "#FFAFAF";
        }
        tag += `<td style = 'background-color: ${hereColor}; border: 1px solid black; padding: 0.1rem'></td>`;
      }
      tag += "</tr>";
    }
    setArea(tag);
  };

  // 데이터 크기 제한
  const [numofRows, setNumofRows] = useState(0);
  const [numofCols, setNumofCols] = useState(0);

  const getSession = () => {
    setNumofRows(parseInt(sessionStorage.getItem("numofRows")));
    setNumofCols(parseInt(sessionStorage.getItem("numofCols")));
  };

  useEffect(() => {
    getSession();
  }, []);

  // 엑셀 데이터 받기
  const getData = () => {
    let preData = [
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        8.02468e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -2.70265e-28, -2.71312e-30, 6.25632e-33, 2.40472e-33, 0, 4.88038e-33, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -2.57191e-27, -1.2916e-27, -6.74902e-28, -1.26847e-28, -2.34722e-29,
        -7.49436e-33, -1.54855e-32, 3.83284e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -3.53507e-27, -2.51082e-27, -2.45019e-27, -1.37683e-27, -7.80467e-28,
        -1.43521e-28, -1.60217e-32, -1.60679e-32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -3.06418e-27, -2.52121e-27, -2.54983e-27, -2.53264e-27, -2.56795e-27,
        -1.49425e-27, -1.71715e-32, -1.50203e-32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -9.81026e-28, -1.59962e-27, -2.15181e-27, -2.58655e-27, -2.58048e-27,
        -2.51812e-27, -7.10433e-31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        -1.06626e-27, -1.99039e-26, -3.06579e-26, -1.08607e-27, -9.52545e-28,
        -9.0348e-28, -8.77462e-29, -2.72751e-32, -2.73642e-32, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.45958e-26,
        -2.84694e-25, -1.30758e-24, -5.89622e-25, 2.93925e-29, -1.29825e-30,
        -1.17283e-30, -1.16145e-30, -5.18159e-31, -8.32062e-31, -1.16788e-29,
        -8.99411e-29, -1.41748e-28, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 5.1043e-34, 1.29616e-33, 4.9822e-33, 5.67841e-33, 5.60748e-33,
        6.07809e-33, 7.89419e-33, 9.09032e-33, 1.5718e-32, 1.59944e-32,
        1.03713e-32, 8.14374e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7.75847e-24,
        1.1259e-23, -2.04365e-23, -4.91742e-23, -1.20355e-23, -6.12315e-29,
        -6.93605e-29, -4.09985e-28, -2.02855e-27, -8.28833e-27, -3.50147e-26,
        -7.66956e-26, -9.58833e-26, -5.03811e-28, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, -4.04997e-33, 2.45565e-34, 6.01188e-33, 6.82639e-33,
        7.70834e-33, 9.32913e-33, 1.33099e-32, 1.41347e-32, 1.47124e-32,
        1.1907e-32, 4.89455e-33, 5.2769e-33, 5.74126e-33, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6.17369e-22,
        2.1171e-21, 8.38737e-22, -7.07408e-22, -9.93462e-22, -6.33589e-22,
        -6.20321e-25, -6.13464e-25, -6.17303e-25, -6.61518e-25, -8.39459e-25,
        -1.23907e-24, -1.1447e-24, -3.02211e-25, -1.89161e-25, -1.53443e-26,
        3.94126e-33, 0, -4.99254e-34, -4.30702e-34, 0, 0, 0, 0, 0, 0, 0,
        1.83622e-33, 3.36941e-33, 4.58941e-33, 5.4223e-33, 6.46419e-33,
        7.45679e-33, 8.43881e-33, 8.61826e-33, 3.76258e-33, 3.90338e-33,
        3.06395e-33, -5.74154e-33, 4.39865e-33, -3.17067e-34, -2.57051e-34, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4.06677e-21,
        3.801e-20, 8.77986e-20, 3.60954e-20, -8.48035e-21, -1.22497e-20,
        -1.92666e-20, -1.44384e-20, -9.02758e-24, -8.74814e-24, -8.44243e-24,
        -6.82966e-24, -3.27273e-24, -1.18056e-24, -3.78429e-25, 1.78791e-25,
        4.36623e-26, -1.08078e-32, -1.56315e-32, -1.57301e-32, -1.58366e-32,
        -1.49494e-32, -1.52928e-32, 3.30409e-33, 2.79134e-33, 1.56892e-33,
        2.91462e-33, 2.85633e-33, 4.45705e-33, 4.63446e-33, 5.54913e-33,
        4.49499e-33, -4.09782e-33, -6.39829e-33, -7.00375e-33, -4.96718e-33,
        -4.39146e-33, -4.73785e-33, -1.11172e-32, -7.79197e-32, -1.1889e-32,
        -4.84484e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1.01962e-22,
        -4.33838e-22, 8.69837e-20, 8.45308e-19, 2.08308e-18, 2.05876e-18,
        -1.34921e-19, -1.63881e-19, -2.16668e-19, -4.44309e-19, -3.45673e-19,
        -1.73903e-20, -3.22375e-24, -3.001e-24, -1.07922e-24, 1.84098e-24,
        1.66908e-24, 4.10331e-25, -6.97715e-27, 7.36912e-32, 3.01242e-32,
        2.93929e-32, 2.3653e-33, 2.32689e-33, -5.06363e-34, 9.2138e-34,
        5.2377e-34, 2.83519e-33, 3.29969e-33, 3.72945e-33, 3.82201e-33,
        2.8476e-34, -2.92252e-33, -2.1036e-33, 3.32153e-33, -6.24105e-33,
        -3.67127e-33, -3.75193e-33, -4.57233e-33, -1.2485e-26, -1.26295e-25,
        -6.23806e-34, -4.84696e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -3.70535e-21,
        -9.66732e-21, -8.96235e-21, 1.50876e-18, 1.41605e-17, 3.67306e-17,
        4.8835e-17, 4.25118e-17, -1.12517e-18, -2.75216e-18, -3.33792e-18,
        -4.95132e-18, -3.16881e-18, -4.95454e-19, 2.59161e-24, 2.53921e-24,
        2.7112e-24, 5.82295e-24, -9.98135e-26, 1.34334e-31, 2.69425e-32,
        2.24608e-32, -4.60738e-34, -1.79241e-33, -1.73519e-33, -1.47593e-33,
        9.86235e-33, 4.34728e-32, 1.085e-31, 1.71357e-31, 3.16643e-31,
        5.66257e-31, 9.49424e-31, 1.49015e-30, -1.47844e-31, -1.17542e-21,
        -7.48897e-21, -3.92876e-21, -4.21788e-22, -4.15089e-22, 4.49789e-28, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -3.29091e-20,
        -2.22495e-19, -3.87037e-19, -3.79932e-19, 2.15354e-17, 1.43502e-16,
        3.43696e-16, 4.91061e-16, 5.06417e-16, 2.31928e-16, -1.72144e-17,
        -1.75734e-17, -1.96297e-17, -1.64432e-17, -5.83054e-18, -5.48547e-19,
        -1.657e-20, 1.2795e-23, 1.06527e-23, -5.98863e-30, -4.15021e-30,
        -6.91211e-31, -4.14439e-34, -1.92488e-33, -1.71517e-33, -1.31187e-33,
        2.29192e-32, 7.36955e-32, 1.03489e-31, -7.5992e-22, -1.69084e-20,
        -5.17093e-20, -1.0892e-19, -1.5633e-19, -2.61408e-19, -1.19729e-18,
        -1.05668e-18, -6.05218e-20, -1.73649e-21, -1.68122e-21, -2.6324e-34, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1.58414e-21,
        -1.25495e-18, -5.22005e-18, -9.25364e-18, -5.61597e-18, 2.11324e-16,
        8.14491e-16, 1.6639e-15, 2.25325e-15, 2.30478e-15, 1.27477e-15,
        5.96589e-17, -4.60247e-17, -4.71927e-17, -3.84226e-17, -1.36194e-17,
        -3.04312e-18, -3.19399e-18, 2.59659e-22, 1.75277e-22, 1.46467e-22,
        9.12138e-23, 4.53875e-23, 4.60338e-23, 4.649e-23, 4.76077e-23,
        4.77314e-23, -1.36983e-23, -9.88629e-21, -5.49226e-20, -7.99844e-20,
        -1.02298e-19, -1.14309e-19, 2.01928e-17, 5.97141e-16, -2.58512e-18,
        -1.40717e-19, -1.87171e-21, -2.83315e-21, -1.67269e-21, 1.29953e-32,
        1.35371e-32, 1.38946e-32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6.52794e-20,
        -3.05876e-19, -1.79059e-17, -6.5791e-17, -1.06751e-16, -5.91083e-17,
        8.99678e-16, 2.89796e-15, 5.43559e-15, 7.71992e-15, 8.11028e-15,
        5.15329e-15, 6.40058e-16, -6.70424e-17, -5.25502e-17, -3.3621e-17,
        -2.48967e-17, -1.32766e-16, -2.2511e-16, -4.29644e-16, -1.04538e-15,
        -1.79318e-15, -2.13979e-15, -2.72944e-15, -3.9164e-15, -4.497e-15,
        -4.96602e-15, -5.45804e-15, -5.77208e-15, 1.48971e-15, 3.6599e-12,
        1.59063e-11, 6.58512e-11, 5.97731e-12, -4.80292e-18, -1.80986e-18,
        -1.49492e-19, -1.83544e-21, -1.82548e-21, -1.23539e-21, -9.53244e-34,
        -8.86292e-34, -4.60538e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -5.84446e-19,
        3.55327e-19, -5.13728e-19, -1.61964e-16, -6.63169e-16, -1.24658e-15,
        -1.45917e-15, 2.35705e-16, 6.91362e-15, 1.44515e-14, 1.89913e-14,
        2.01366e-14, 1.65688e-14, 1.35435e-14, 1.79098e-14, 3.16983e-14,
        3.83005e-14, 2.49151e-14, 9.50619e-16, -2.3608e-15, -1.90479e-15,
        -2.67507e-15, -4.70633e-15, -6.36034e-15, -6.82969e-15, 9.42063e-12,
        5.33041e-11, 1.64798e-10, 3.59986e-10, 6.85549e-10, 1.53332e-9,
        3.90432e-9, 1.05669e-8, 9.04324e-9, -3.54261e-18, -2.80168e-18,
        6.27368e-22, 3.00717e-22, 8.14756e-23, 1.09021e-23, 0, -4.35364e-34,
        -4.59024e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0.0000051753, 7.347049, 36.87047,
        93.41212, 192.5415, 264.2397, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -3.38636e-17,
        -2.92552e-18, -2.7255e-18, -5.06916e-17, -1.62957e-15, -5.64826e-15,
        -1.03459e-14, -1.27872e-14, -1.16261e-14, 7.14974e-16, 1.87027e-14,
        3.69672e-14, 6.29987e-14, 1.16465e-13, 2.15244e-13, 3.67982e-13,
        5.4891e-13, 6.99309e-13, 7.13227e-13, 6.33712e-13, 4.60786e-13,
        2.60645e-13, 1.01312e-13, 4.48226e-14, 4.46259e-14, 1.19612e-11,
        7.54183e-11, 2.0862e-10, 2.18168e-10, 9.04752e-11, 4.01699e-11,
        -1.45384e-11, 3.36166e-8, 1.82168e-7, 2.75502e-7, 1.68733e-14,
        1.71342e-22, 1.73138e-22, 7.8531e-23, 8.3996e-24, 4.56387e-34,
        1.59518e-16, 8.16741e-15, 0, 0, 0, 0, 0, 0, 0, 0.2611548, 46.76805,
        78.23766, 131.7052, 156.5714, 181.4028, 107.4235, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7.0799e-14,
        -5.31979e-17, -1.9367e-17, -1.81332e-17, -1.57508e-17, -2.78144e-15,
        -1.30027e-14, -2.7528e-14, -4.00587e-14, -4.49062e-14, -4.43287e-14,
        -3.03438e-14, -3.86122e-15, 3.43665e-14, 8.19049e-14, 1.38819e-13,
        2.36864e-13, 4.38661e-13, 7.01772e-13, 7.53561e-13, 6.6638e-13,
        4.98801e-13, 2.95821e-13, 1.25695e-13, 5.61171e-14, 5.32516e-14,
        2.04238e-12, 2.80524e-10, 2.37375e-9, 4.02149e-10, 3.93275e-10,
        -3.31682e-12, -3.31825e-12, -5.50251e-12, 6.57037e-7, 0.00000594078,
        0.0000168319, 0.0000225119, 0.0000125587, 0.00000556292, 2.2436e-22,
        2.23889e-22, 3.89857e-13, 7.04188e-12, 2.53344e-21, 3.05894e-21, 0, 0,
        0, 0, 0.4591753, 32.33694, 100.8251, 105.5667, 131.6941, 129.3817,
        86.47806, 11.711, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.49992e-11,
        -4.02202e-17, -3.75932e-17, -2.51551e-17, -1.65679e-18, 5.51973e-17,
        -2.4742e-14, -4.40118e-14, -4.4145e-14, -4.65438e-14, -5.49251e-14,
        -5.48596e-14, -5.50851e-14, -5.3909e-14, -5.26899e-14, -1.12833e-14,
        7.80808e-14, 8.67501e-14, 1.18205e-13, 9.25339e-13, 5.36898e-12,
        5.46396e-11, 1.15867e-10, 2.23214e-10, 4.17337e-10, 8.87579e-10,
        2.64936e-9, 5.12333e-9, 3.3053e-10, 5.04808e-11, 4.95325e-11,
        3.47234e-12, 2.61922e-13, -9.73845e-14, -3.53136e-12, 0.0000392596,
        0.000920119, 0.003089049, 0.005814124, 0.00690145, 0.006314345,
        0.002798706, 0.00058104, -2.95607e-9, -3.34145e-9, 6.07573e-21,
        -8.16334e-23, -5.094e-22, 4.5343e-23, 0.5291187, 25.21514, 75.76273,
        97.96961, 94.23476, 98.44662, 58.36694, 21.98892, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.07032e-9,
        1.36411e-9, 1.29881e-9, 9.73642e-10, 7.38368e-10, 4.90899e-10,
        3.23889e-10, 2.03424e-10, 1.40602e-10, 1.05781e-10, 9.59217e-11,
        9.44549e-11, 1.02806e-10, 1.08342e-10, 1.19594e-10, 1.34377e-10,
        1.58691e-10, 1.88891e-10, 2.31941e-10, 2.82799e-10, 3.49479e-10,
        3.99183e-10, 4.48296e-10, 4.61797e-10, 4.3662e-10, 2.33764e-9,
        1.27113e-8, 1.30716e-8, 6.86685e-9, 9.57069e-11, 9.45896e-11,
        1.9613e-11, 4.51714e-12, 4.08155e-12, -1.48038e-13, 0.0000919174,
        0.003502039, 0.01280647, 0.02524238, 0.03155421, 0.03255918, 0.02264505,
        0.01032453, -0.0000040099, -0.00000399793, -0.0000025186, -8.05201e-7,
        6.45779e-8, 3.293739, 19.23258, 56.68632, 72.49678, 84.37208, 61.74823,
        48.82622, 13.49934, 0.02675693, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9.53974e-9,
        6.97178e-9, 6.23681e-9, 5.17028e-9, 4.48737e-9, 3.73254e-9, 3.14211e-9,
        2.56504e-9, 2.16736e-9, 1.82207e-9, 1.60846e-9, 1.41421e-9, 1.29411e-9,
        1.17367e-9, 1.0983e-9, 1.01233e-9, 9.53987e-10, 8.84394e-10,
        8.39001e-10, 7.77777e-10, 7.21084e-10, 6.24448e-10, 5.45823e-10,
        4.7666e-10, 4.67681e-8, 5.78172e-7, 6.10327e-7, 7.61221e-8, 7.40871e-8,
        3.58895e-9, 3.0035e-9, 7.54829e-11, 7.41217e-11, 7.40743e-12,
        7.65357e-12, 0.000466439, 0.005622604, 0.01602248, 0.02679719,
        0.0280606, 0.02387471, 0.008680707, 0.000793425, -0.00000564942,
        -0.00000482909, -0.00000274519, -6.94581e-7, 0.02853674, 9.311466,
        41.58403, 58.8212, 62.27083, 64.70884, 32.08056, 17.35006, 0.01034938,
        1.82764e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.65203e-8,
        1.28062e-8, 1.15568e-8, 9.62884e-9, 8.5233e-9, 7.30605e-9, 6.43929e-9,
        5.46435e-9, 4.74371e-9, 3.95976e-9, 3.40277e-9, 2.87696e-9, 2.57178e-9,
        2.26843e-9, 2.05772e-9, 1.78839e-9, 1.57129e-9, 1.31736e-9, 1.11667e-9,
        8.99217e-10, 7.36055e-10, 6.34072e-10, 5.64228e-10, 0.00000144665,
        0.00000661287, 0.00000660837, 0.00000226514, 6.66946e-7, 2.92536e-7,
        2.33244e-7, 3.54392e-8, 7.94969e-9, 7.77849e-9, 9.87627e-11,
        9.57382e-11, -1.45502e-11, -1.45771e-11, 0.000418706, 0.003943906,
        0.008856427, 0.0109356, 0.008781934, 0.00375479, -0.00000406609,
        -0.0000040735, -0.00000288968, 0.5314609, 7.080295, 23.32025, 41.04283,
        50.93633, 44.99583, 44.66638, 12.59974, 5.211192, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.01281e-8,
        1.59022e-8, 1.49889e-8, 1.29666e-8, 1.15712e-8, 9.86308e-9, 8.40643e-9,
        6.72261e-9, 5.68809e-9, 5.16176e-9, 4.73012e-9, 4.16233e-9, 3.66538e-9,
        3.13187e-9, 2.69022e-9, 2.2358e-9, 1.85399e-9, 1.47929e-9, 1.17583e-9,
        9.08548e-10, 7.62096e-10, 0.00000211929, 0.00003784, 0.0000753933,
        0.0000765996, 0.0000137515, 0.0000134514, 0.00000259104, 0.00000254996,
        4.86426e-7, 4.78411e-7, 6.19563e-8, 6.08944e-8, 4.60709e-9, 4.5216e-9,
        1.49918e-10, 1.4961e-10, 0.0000346997, 0.000449591, 0.001227537,
        0.001651566, 0.001290841, 0.000337285, -0.00000406414, -0.0000040717,
        -0.00000284875, 2.266973, 11.83126, 29.85005, 31.02812, 37.32341,
        29.3152, 27.21583, 3.410585, 1.515697, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.97854e-8,
        1.57344e-8, 1.50169e-8, 1.30786e-8, 1.19325e-8, 1.02976e-8, 9.03129e-9,
        7.4189e-9, 6.13435e-9, 5.13498e-9, 4.80749e-9, 4.29807e-9, 3.84372e-9,
        3.2802e-9, 2.80185e-9, 2.29254e-9, 1.87781e-9, 1.48648e-9, 1.21802e-9,
        0.0000015497, 0.0000550578, 0.000164327, 0.000230854, 0.000237768,
        0.0000724056, 0.0000402335, 0.0000293685, 0.00000831549, 0.00000816946,
        0.00000138355, 0.00000136207, 1.8466e-7, 1.81905e-7, 1.8923e-8,
        1.8648e-8, 1.28657e-9, 1.2666e-9, 7.54149e-12, 6.81775e-12,
        -3.45782e-11, -3.49679e-11, -3.48478e-11, -3.78029e-11, 0.000254602,
        0.1857748, 1.980397, 8.682261, 17.96408, 25.33365, 21.53278, 25.29553,
        14.88228, 12.93151, 0.4307401, 0.4262207, 0.0000139985, 0.0000138383, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.40326e-8,
        2.0199e-8, 1.53778e-8, 1.49564e-8, 1.28947e-8, 1.01934e-8, 9.20265e-9,
        7.56957e-9, 6.58365e-9, 5.51577e-9, 4.77752e-9, 4.13009e-9, 3.82742e-9,
        3.31209e-9, 2.80774e-9, 2.30371e-9, 1.94098e-9, 0.00000543046,
        0.000169263, 0.001178099, 0.001195636, 0.000486676, 0.000515286,
        0.000327755, 0.000246797, 0.0000735552, 0.0000534821, 0.0000216307,
        0.0000187621, 0.00000352475, 0.00000347285, 4.47431e-7, 4.40482e-7,
        3.42187e-8, 3.36739e-8, 2.15166e-9, 2.12087e-9, 1.74207e-10,
        1.72281e-10, 1.7209e-11, -9.83352e-12, -3.11516e-11, -3.78322e-11,
        0.0000842888, 0.190482, 2.544913, 10.75988, 19.50001, 24.63154,
        16.38583, 15.98663, 5.043538, 5.029999, 0.002700501, 0.02255717,
        0.00000555622, 0.00000544224, -1.34438e-12, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.06190227,
        0.04255391, 0.006074216, 0.003431699, 0.000159158, 1.31366e-8,
        1.22857e-8, 7.91035e-9, 7.60446e-9, 5.57819e-9, 5.41727e-9, 4.23281e-9,
        4.15205e-9, 3.84065e-9, 3.38166e-9, 0.000270182, 0.006919983,
        0.02028936, 0.0222708, 0.02695407, 0.03521583, 0.02090154, 0.001111194,
        0.000905212, 0.00045217, 0.000447847, 0.000153208, 0.000110267,
        0.0000396856, 0.0000392569, 0.00000794265, 0.00000784372, 0.0000012597,
        0.00000124377, 1.37822e-7, 1.36086e-7, 1.15518e-8, 1.14097e-8,
        1.11877e-9, 1.10908e-9, 4.3139e-10, 2.53291e-7, 0.00000154344,
        0.0000039386, 0.00000522001, 0.6712265, 7.055738, 14.02492, 17.37624,
        26.39192, 14.71455, 14.85236, 1.138647, 1.173521, 0.00000436718,
        0.00000329613, 0.00000322843, 7.66837e-8, -6.08037e-13, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3568064, 0.3593379,
        0.2508876, 0.1996157, 0.1421316, 0.1027907, 0.07087433, 0.05039311,
        0.03563234, 0.02740041, 0.02241483, 0.02064261, 0.02005322, 0.02080118,
        0.02923608, 0.04822479, 0.0851318, 0.1282403, 0.104794, 0.08719608,
        0.04207465, 0.04181194, 0.01220874, 0.006126081, 0.000858663,
        0.000850528, 0.000300221, 0.000297178, 0.0000860029, 0.0000850531,
        0.0000205452, 0.0000202757, 0.00000266151, 0.00000262524, 1.58105e-7,
        1.55782e-7, 1.15608e-8, 1.1416e-8, 1.15294e-9, 1.15475e-9, 2.73739e-9,
        1.25548e-7, 4.82131e-7, 8.02483e-7, 7.32432e-7, 1.088187, 7.04849,
        14.01817, 17.37173, 27.80175, 12.57193, 3.998415, 0.08459089,
        0.08125429, 0.00000141505, 0.0000012721, 6.01502e-7, 8.16851e-14,
        7.41895e-14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.9678971, 0.9813674,
        0.8497791, 0.7685124, 0.6544468, 0.5661304, 0.466751, 0.3894374,
        0.3084785, 0.248263, 0.1900711, 0.1515444, 0.1197006, 0.1066106,
        0.1006418, 0.1159933, 0.1379187, 0.1386633, 0.1197183, 0.1196689,
        0.08081503, 0.07226323, 0.04295688, 0.03118097, 0.01080072, 0.00458424,
        0.000819624, 0.000805745, 0.000276167, 0.000189505, 0.0000705914,
        0.0000690477, 0.0000123913, 0.0000122549, 0.00000131173, 0.000001297,
        8.62133e-8, 8.52628e-8, 7.36978e-9, 7.31077e-9, 2.57504e-9, 7.86621e-9,
        1.5072e-8, 1.02519e-7, 0.00000114682, 1.037475, 6.304937, 11.01571,
        14.70561, 7.296773, 0.7771995, 0.663014, 0.00000238354, 0.00000235407,
        8.96001e-7, 1.0945e-7, 4.27601e-8, 8.15392e-14, 7.33052e-14, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.790324, 1.708067,
        1.614294, 1.538624, 1.42761, 1.340057, 1.216448, 1.116843, 0.9845942,
        0.8741534, 0.7384972, 0.6244151, 0.493181, 0.3891489, 0.2817592,
        0.2255647, 0.1661042, 0.1659287, 0.151243, 0.1533301, 0.1277314,
        0.1275972, 0.09239093, 0.0853349, 0.05942033, 0.0483589, 0.02931597,
        0.02102372, 0.009954951, 0.005643547, 0.000223096, 0.00022119,
        0.0000514907, 0.0000510631, 0.00000131272, 0.0000012992, 8.6487e-8,
        8.54941e-8, 7.41536e-9, 7.37799e-9, 6.21445e-9, 7.8956e-9, 7.63938e-9,
        5.68242e-8, 0.003028709, 0.827449, 4.430871, 10.99221, 7.730903,
        0.05719156, 0.00000600255, 0.00000167143, 0.00000159464, 3.24071e-7,
        3.03201e-7, 1.45801e-12, 1.33431e-12, 1.19147e-13, 2.28872e-15, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.08536, 2.106362,
        2.106645, 2.056232, 2.055031, 1.980991, 1.977198, 1.874205, 1.834636,
        1.719515, 1.636459, 1.478799, 1.347478, 1.133488, 0.9293123, 0.6385869,
        0.3948891, 0.1801591, 0.1801403, 0.169188, 0.1809968, 0.1664745,
        0.1720403, 0.1548509, 0.1568106, 0.1409226, 0.1445439, 0.1324666,
        0.1354326, 0.1114609, 0.1052394, 0.04585999, 0.01782304, 0.0003477,
        0.000344563, 0.0000425333, 0.0000421589, 0.00000329655, 0.00000326524,
        1.5754e-7, 1.55884e-7, 6.38292e-9, 7.89784e-9, 7.63926e-9, 0.0000087887,
        0.003238043, 0.8633456, 5.941286, 9.976381, 2.13704, 0.00000218029,
        0.00000213357, 5.05208e-7, 4.91606e-7, 6.2834e-8, 6.64073e-8,
        4.16404e-13, 4.03615e-13, 3.53476e-14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.100182, 2.141159,
        2.1669, 2.166881, 2.202983, 2.198094, 2.222371, 2.202725, 2.214065,
        2.165051, 2.162943, 2.045454, 1.968167, 1.774763, 1.557019, 1.175719,
        0.7460174, 0.3433645, 0.2155015, 0.214786, 0.2291753, 0.2181423,
        0.2295018, 0.2191143, 0.2343566, 0.2312461, 0.270527, 0.2730486,
        0.2976134, 0.2942579, 0.30784, 0.2517463, 0.1912206, 0.01014471,
        0.0000434443, 0.0000429487, 0.0000424657, 0.00000334701, 0.00000329986,
        1.64981e-7, 1.65423e-7, 1.36357e-8, 0.00000233092, 0.0000316461,
        0.02077218, 3.126225, 5.833404, 5.925055, 5.774155, 0.05142317,
        0.0000020044, 4.29838e-7, 6.7531e-8, 5.91872e-8, 3.96304e-10,
        1.88183e-10, 3.53282e-13, 4.66008e-14, 3.76587e-14, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.061772, 2.111636,
        2.155988, 2.158325, 2.203637, 2.202495, 2.247745, 2.246986, 2.292581,
        2.283755, 2.319998, 2.299935, 2.316278, 2.212718, 2.126123, 1.853074,
        1.499556, 0.9337747, 0.4673482, 0.2710654, 0.2709126, 0.2560212,
        0.2709293, 0.2535978, 0.2839701, 0.2877936, 0.3700206, 0.3775969,
        0.4122933, 0.4085042, 0.4405302, 0.4280327, 0.4576666, 0.4909516,
        0.5892736, 0.6812377, 0.8151103, 0.9474585, 1.118634, 1.292014,
        1.542669, 1.936034, 2.853025, 3.964906, 4.868171, 5.095828, 5.628021,
        3.850747, 1.490789, 0.00000156561, 0.00000150526, 3.457e-8, 3.01175e-8,
        7.31522e-13, 7.30226e-13, 3.55662e-13, 2.29493e-13, 1.90759e-14,
        1.79023e-14, -8.21148e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.525823, 1.784833,
        1.862777, 1.955722, 2.064114, 2.127616, 2.215542, 2.248036, 2.304712,
        2.307964, 2.345514, 2.345576, 2.387327, 2.379369, 2.400053, 2.284955,
        2.134953, 1.756798, 1.238685, 0.387998, 0.3858126, 0.3709772, 0.3849405,
        0.3567373, 0.362526, 0.3390971, 0.5354245, 0.5420404, 0.5886548,
        0.588432, 0.6218097, 0.5819263, 0.7474095, 1.211021, 1.544817, 1.849803,
        2.168208, 2.440557, 2.746635, 3.081243, 3.738613, 4.388257, 4.674882,
        4.805749, 4.831302, 4.038367, 2.780326, 1.038102, 0.02420174,
        0.00000146134, 4.72353e-7, 2.45982e-8, 2.24609e-8, 2.07361e-13,
        2.02299e-13, 6.00161e-14, 8.55033e-14, 1.93907e-15, 1.14498e-15,
        -2.61005e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.7732718, 0.8350834,
        1.058683, 1.190921, 1.304357, 1.445994, 1.56118, 1.718075, 1.840669,
        2.00715, 2.122593, 2.272805, 2.327813, 2.390031, 2.391184, 2.440728,
        2.428835, 2.43203, 2.161817, 1.780179, 1.149536, 0.5168855, 0.5127778,
        0.5622624, 0.5622718, 0.702642, 0.8398064, 0.8924044, 0.8909029,
        0.9591444, 0.9593422, 1.057674, 1.057761, 1.477755, 2.16879, 2.694432,
        3.098391, 3.468703, 3.695057, 3.931343, 4.293389, 4.368349, 4.369814,
        4.085779, 3.534027, 2.684529, 1.618933, 0.6001272, 0.01755351,
        0.00000301159, 0.00000100805, 4.01179e-8, 2.71684e-8, 5.09369e-9,
        8.83803e-14, 7.55146e-14, 1.09901e-16, 1.71142e-15, 1.55094e-17, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3922953, 0.4127304,
        0.4755408, 0.5587082, 0.6410584, 0.7459343, 0.8523032, 0.9893929,
        1.129976, 1.309342, 1.488474, 1.710118, 1.916538, 2.15218, 2.321682,
        2.453133, 2.477702, 2.500405, 2.496921, 2.424733, 2.092408, 1.568342,
        0.7705379, 0.7595903, 0.7260245, 1.008569, 1.010797, 1.130265, 1.169675,
        1.305554, 1.305866, 1.462996, 1.46388, 2.330105, 3.093712, 3.535087,
        3.727171, 3.801889, 3.80255, 3.919064, 3.662474, 3.24809, 2.666753,
        2.104283, 1.417802, 0.7540747, 0.2083874, 0.003156265, 0.00000459051,
        0.00000121364, 1.2316e-7, 1.2213e-8, 1.31658e-8, 6.86809e-11,
        1.45809e-13, 1.30858e-15, 1.42958e-17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.07055607, 0.0744756,
        0.09061232, 0.117833, 0.1534616, 0.203975, 0.2637116, 0.3391839,
        0.4307558, 0.5554741, 0.701192, 0.8944955, 1.108381, 1.379663, 1.658433,
        1.981678, 2.243398, 2.473243, 2.503879, 2.524349, 2.51391, 2.370559,
        2.16303, 2.050591, 1.877901, 1.941538, 1.352851, 1.195119, 1.03922,
        1.214196, 1.209667, 1.465226, 1.842106, 3.217863, 3.622786, 3.714066,
        3.714444, 3.489251, 2.965228, 2.346092, 1.73452, 1.302319, 0.8714938,
        0.527624, 0.2131431, 0.03355066, 0.0000112229, 0.000010324,
        0.00000117959, 5.96469e-8, 6.87932e-9, 3.01157e-9, 7.96386e-10,
        2.04966e-12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.00000162802,
        0.00000164347, 0.0000034052, 0.0000145447, 0.0000842866, 0.000522844,
        0.006040906, 0.02269504, 0.04710639, 0.08657454, 0.1478048, 0.2439651,
        0.3829587, 0.5592359, 0.7900932, 1.092754, 1.440891, 1.841899, 2.21664,
        2.52432, 2.619847, 2.668795, 2.671489, 2.686513, 2.678297, 2.603304,
        2.568785, 2.534532, 2.481119, 2.51757, 2.575689, 2.740772, 2.989311,
        3.600422, 3.613169, 3.369475, 2.741016, 1.946693, 1.123316, 0.546482,
        0.2959887, 0.1447957, 0.05543854, 0.009845931, 0.00000226948,
        0.00000217624, 6.29967e-7, 2.51362e-7, 2.40841e-7, 1.24971e-8,
        1.18188e-8, 7.44054e-9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.00000128467,
        0.00000130846, 0.00000130907, 0.00000134387, 0.00000141734,
        0.00000173403, 0.00000173322, 0.0000020275, 0.00000254986,
        0.00000430384, 0.0000130857, 0.0000547568, 0.004826087, 0.048258,
        0.1235923, 0.2554308, 0.4589231, 0.7347235, 1.064399, 1.465816,
        1.858867, 2.225306, 2.478666, 2.657601, 2.770827, 2.877068, 2.896918,
        3.184167, 3.240887, 3.310451, 3.312146, 3.391426, 3.411217, 3.469231,
        2.78233, 2.112937, 1.299427, 0.5967888, 0.1008481, 0.002827166,
        0.00000347562, 0.00000343218, 0.00000305271, 0.00000268537,
        0.00000219572, 0.00000114113, 6.99916e-7, 4.17515e-7, 4.11292e-7, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0000011457,
        0.00000117712, 0.00000120606, 0.00000128146, 0.00000136256,
        0.0000015048, 0.00000168438, 0.00000192616, 0.00000223048,
        0.00000269283, 0.00000321335, 0.00000383753, 0.00000466202,
        0.00000572896, 0.0000379046, 0.000234627, 0.004755604, 0.0498533,
        0.1468544, 0.2936922, 0.4912639, 0.7264811, 0.9518591, 1.142807,
        1.285592, 1.392147, 1.377193, 1.966896, 2.239326, 2.432929, 2.451056,
        2.334101, 2.063965, 1.61003, 1.117037, 0.6774393, 0.2952698, 0.06891512,
        -6.53299e-13, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.84064e-18, -1.09142e-19,
        2.10899e-17, 2.21384e-17, 4.38796e-16, 1.93358e-15, 1.28799e-14,
        8.10787e-14, 5.50235e-13, 2.56899e-12, 1.91701e-11, 1.16971e-10,
        7.54426e-10, 4.90836e-9, 3.21999e-8, 2.17893e-7, 2.70156e-7, 3.36233e-7,
        0.00000218205, 0.0000141385, 0.0000889663, 0.000530194, 0.003933042,
        0.0319233, 0.06859397, 0.124723, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.33899e-33,
        1.25638e-33, 5.06159e-34, 3.28778e-34, 3.08636e-34, 3.64513e-34,
        9.25253e-34, 5.15618e-34, 1.15671e-33, 1.23049e-33, 1.36487e-33,
        1.19632e-33, 4.89128e-34, 5.82272e-34, 4.75825e-34, 5.6413e-34,
        6.6691e-34, 7.94284e-34, 9.37422e-34, 1.1146e-33, 1.33196e-33,
        1.59717e-33, 1.92703e-33, 2.11871e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.34082e-33,
        1.26085e-33, 4.18631e-34, 5.10141e-34, 6.31077e-34, 7.69624e-34,
        9.48136e-34, 9.79924e-34, 1.19503e-33, 1.27477e-33, 1.4196e-33,
        1.24919e-33, 1.22352e-33, 9.19675e-34, 1.11068e-33, 1.33057e-33,
        1.53267e-33, 1.53445e-33, 1.75384e-33, 1.67475e-33, 1.99236e-33,
        2.37136e-33, 2.82404e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.19055e-33, 1.4379e-33,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2.94793e-34,
        3.23126e-34, 2.99448e-34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3.48265e-34, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1.72716e-33,
        1.76496e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9.81852e-34,
        1.73067e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1.77291e-33,
        -1.63831e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2.59272e-33,
        -2.6306e-33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1.16802e-33, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
      [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0,
      ],
    ];

    if (preData !== null && preData !== "undefined" && preData !== "[]") {
      let fromPreData = [];

      preData.map((arr) => {
        let prestr = "";
        for (let i = 0; i < preData[0].length; i++) {
          prestr = prestr + arr[i] + "\t";
        }
        prestr = prestr.slice(0, prestr.length - 1);
        fromPreData += prestr;
        fromPreData += "\n";
      });
      setData(fromPreData);
    }

    let rows = [];

    let rawRows = data.split("\n");
    rawRows.splice(rawRows.length - 1, 1);
    setNumOfRows(rawRows.length);
    let columnList = [];
    let firstCol = "white";
    let color = "white";

    rawRows.forEach((rawRows, idx) => {
      let rawRowArray = rawRows.split("\t");
      columnList.push(rawRowArray.length);
      output.push(rawRowArray);
      rows.push(
        `<tr style = 'background-color: ${firstCol};'><td style = 'background-color: ${color}; border: 1px solid black; padding: 10px'>${rawRowArray.join(
          "</td><td style = 'border: 1px solid black; padding: 10px'>"
        )}</td></tr>`
      );
    });

    rows = rows.join("");
    setNumOfColumns(Math.max(...columnList));

    if (numOfRows > 1 && numOfColumns > 1) {
      //   if (numOfRows !== numofRows || numOfColumns !== numofCols) {
      //     // alert("입력된 데이터의 크기가 올바르지 않습니다.");
      //     // reset();
      //   } else {
      setSizeCheck(`입력된 데이터 크기 : ${numOfRows} X ${numOfColumns} `);
      setVisibleBtn("inline-block");
      setVisibleArea("none");
      makeGrid(output, numOfRows, numOfColumns);
      makeJSON(numOfRows);
      //   }
    } else if (numOfRows < 1) {
      setVisibleBtn("none");
      setVisibleArea("inline-block");
    }
    setBodyRows(rows);
  };

  const reset = () => {
    sessionStorage.removeItem("waterlevel");

    setData("");
    setArea();
    setVisibleBtn("none");
    setVisibleArea("inline-block");
    setNumOfColumns(0);
    setNumOfRows(0);
    setBodyRows([]);
    setJSONString();
    setSizeCheck("");
    resetVisible();
  };

  const resetVisible = () => {
    setVisibleBtn("none");
    setVisibleArea("inline-block");
  };

  // json
  const makeJSON = (numOfRows) => {
    output = output.splice(0, numOfRows);
    setJSONString(JSON.stringify(output));
    const jsonstr = JSON.stringify(output);
    let result = "";
    const arr = [...jsonstr];
    arr.map((s) => {
      if (s !== '"') {
        result += s;
      }
    });
  };

  // json 새 창
  const openData = () => {
    window.open("/satsoilconc", "", "_blank");
  };

  useEffect(() => {
    getData();
  });

  return (
    <>
      <textarea
        style={{ display: visibleArea }}
        id="satsoilconc"
        onChange={constructTableFromPasetedInput}
        value={data}
        placeholder="엑셀 데이터를 복사하여 여기에 붙여넣어주세요."
      ></textarea>
      <div style={{ display: visibleBtn }}>
        <S.BtnBox>
          <p dangerouslySetInnerHTML={{ __html: sizeCheck }}></p>
          <div>
            <S.CheckBtn onClick={openData}>데이터 세부 확인</S.CheckBtn>
            <S.CheckBtn>다시 입력</S.CheckBtn>
          </div>
        </S.BtnBox>
        <S.GridAndLegend>
          <S.GridTable
            style={{ display: visibleBtn }}
            dangerouslySetInnerHTML={{ __html: area }}
          ></S.GridTable>
          <div>
            <S.Legend>
              <h5>오염농도 (최고농도 = 100 기준)</h5>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#ff0000",
                }}
              ></S.LegendItem>
              <span>{`≥ 90`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF1818",
                }}
              ></S.LegendItem>
              <span>{`80 ≤ x < 90`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FD2F2F",
                }}
              ></S.LegendItem>
              <span>{`70 ≤ x < 80`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF4141",
                }}
              ></S.LegendItem>
              <span>{`60 ≤ x < 70`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF5C5C",
                }}
              ></S.LegendItem>
              <span>{`50 ≤ x < 60`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF6F6F",
                }}
              ></S.LegendItem>
              <span>{`40 ≤ x < 50`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF7E7E",
                }}
              ></S.LegendItem>
              <span>{`30 ≤ x < 40`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FD8B8B",
                }}
              ></S.LegendItem>
              <span>{`20 ≤ x < 30`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FF9D9D",
                }}
              ></S.LegendItem>
              <span>{`10 ≤ x < 20`}</span>
            </S.Legend>
            <S.Legend>
              <S.LegendItem
                style={{
                  backgroundColor: "#FFAFAF",
                }}
              ></S.LegendItem>
              <span>{`x < 10`}</span>
            </S.Legend>
          </div>
        </S.GridAndLegend>
      </div>
    </>
  );
};

export default SatConc;
